import {
  RESET_COMPANY,
  SET_COMPANY,
  SET_PAYMENT_IN_CASH,
  SET_DELIVERY_WITH_RETURN,
  SET_MAX_DELIVERIES,
} from "../../types";
import { Company } from "../../../models/Company";

export const setCompany = (payload: Company) => ({
  type: SET_COMPANY,
  payload,
});

export const setPaymentInCashState = (payload: boolean) => ({
  type: SET_PAYMENT_IN_CASH,
  payload,
});

export const setMaximumDeliveriesState = (payload: number) => ({
  type: SET_MAX_DELIVERIES,
  payload,
});

export const setDeliveryWithReturnState = (payload: boolean) => ({
  type: SET_DELIVERY_WITH_RETURN,
  payload,
});

export const resetCompany = () => ({
  type: RESET_COMPANY,
});
